module.exports = __webpack_public_path__ + "img/google-logo.14137f89.svg";